import { variantBorder } from '@components/Buttons/utils';
import { margin, MarginProps } from '@lib/style/mixins/margin';
import { padding, PaddingProps } from '@lib/style/mixins/padding';
import { prop } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { createMemo } from '@packages/react';
import React, { ElementType } from 'react';
import styled, { css } from 'styled-components';

type CompactButtonProps<C extends ElementType = any> = ButtonProps<
    C,
    { component?: C } & Partial<PaddingProps> &
        Partial<MarginProps> & {
            fontSize?: number | string;
        }
>;

const mIcon = css`
    & {
        .material-icons {
            margin-right: 6px;
            font-size: 18px;
        }
    }
`;

export const CompactButton = styled(
    createMemo<CompactButtonProps>(
        ({ elevation, fontSize, ...props }) => {
            margin.clean(props);
            padding.clean(props);

            return <Button role={'button'} {...(props as any)} />;
        },
        {
            displayName: 'CompactButton',
        },
    ),
)<CompactButtonProps>`
    && {
        min-width: 24px;
        line-height: 24px;
        border: ${variantBorder as any};
        min-height: 24px;
        font-size: ${prop('fontSize', undefined, unitStrict)};
        ${margin('0 6px')}
        ${padding('0 6px')}
        ${mIcon}
    }
`;
